import Box from '@mui/material/Box';
import {
  ButtonWithLoader,
  ManageTutorsCategoryData,
} from '../../tutoringV2CommonUtils';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { SpinnerWrapper } from '../../tutoringV2Styled';
import { TimeSlotAccordionPicker } from './TimeSlotsAccordion';
import { ButtonSpinner, ButtonSpinnerProgress } from 'components/Ui/styled';

const TutorDialogCard = ({
  tutor = {},
  getTutorName,
  onRemoveTutor,
  timeSlots = [],
  loading = false,
  cardSlotIds = [],
  onSwitchCategory,
  onUpdateTimeSlots,
  onCardSlotsChange,
  isSwitching = false,
  slotsLoading = false,
  isUpdatingSlots = false,
}) => {
  const tutorName = getTutorName(tutor?.tutorId);
  const formattedCategory =
    tutor?.category?.charAt(0).toUpperCase() + tutor?.category.slice(1);

  const hasRestriction = cardSlotIds?.length > 0;
  const isPrimary = tutor?.category === 'primary';
  const switchLabel = isPrimary ? 'Backup' : 'Primary';

  const restrictionLabel = hasRestriction
    ? `Restricted to ${cardSlotIds?.length} time slot${
        cardSlotIds?.length !== 1 ? 's' : ''
      }`
    : 'All time slots';

  const isDisabled = loading || isSwitching || isUpdatingSlots;

  return (
    <Grid item xs={12}>
      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
        <Typography variant="h6" fontWeight={600}>
          {tutorName}
        </Typography>

        <ManageTutorsCategoryData
          label="Category :"
          value={formattedCategory}
        />

        <Box mt={1} mb={2}>
          <Chip
            size="small"
            variant="outlined"
            label={restrictionLabel}
            color={hasRestriction ? 'warning' : 'success'}
          />
        </Box>

        <Divider sx={{ mb: 2 }} />

        {/* Time Slot Picker */}
        <ButtonSpinner>
          <SpinnerWrapper width="100%">
            <TimeSlotAccordionPicker
              timeSlots={timeSlots}
              selectedIds={cardSlotIds}
              onChange={onCardSlotsChange}
            />
            {slotsLoading && <ButtonSpinnerProgress size={24} />}
          </SpinnerWrapper>
        </ButtonSpinner>

        <Grid
          container
          mt={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item>
            <ButtonWithLoader
              disabled={isDisabled}
              loading={isSwitching}
              label={`Switch to ${switchLabel}`}
              onClick={() => onSwitchCategory?.(tutor)}
            />
          </Grid>

          <Grid item>
            <ButtonWithLoader
              disabled={isDisabled}
              label="Update Time Slots"
              loading={isUpdatingSlots}
              onClick={() => onUpdateTimeSlots?.(tutor)}
            />
          </Grid>

          <Grid item>
            <ButtonWithLoader
              loading={loading}
              label="Remove Tutor"
              disabled={isDisabled}
              onClick={() => onRemoveTutor?.(tutor)}
            />
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default TutorDialogCard;
